/* global femcare */

$(document).ready(function () {
    femcare.periodTracker.calculator.init({ skipRendering: true }); // Period Calculator v3
    femcare.form.circularDatePicker.init();
});
